// MAP FEATURE_NAME TO FEATURE_ID
export const FEATURE = {
  SUMMARY_DASHBOARD: '1',
  ADMIN_DASHBOARD: '2',
  DASHBOARD_MANAGEMENT: '3',
}
